import { GTM_CONTAINER_ID } from '../config';

// Google Tag Manager loader for the ad-warming pilot. Mirrors the Meta pixel: it
// plants the GTM container so campaign tags (conversions, retargeting) can fire on
// visitors from the warming ads. Gated by VITE_GTM_CONTAINER_ID (set only in the
// brand's env, e.g. .env.gop for the Republican build), so non-configured builds
// are a pure no-op.

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
    __gtmInitialized?: boolean;
  }
}

function ensureDataLayer(): Record<string, unknown>[] {
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
}

function loadGtmScript(containerId: string): void {
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
  const firstScript = document.getElementsByTagName('script')[0];
  // In a real page main.tsx is itself a <script>, so we insert before it; in tests
  // (or any script-less document) fall back to appending to <head>.
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }
}

/**
 * Initialize Google Tag Manager: push the `gtm.js` start event and load the
 * container script. No-op (returns false) when no container id is configured or
 * it has already been initialized.
 * @returns whether GTM was initialized on this call.
 */
export function initGtm(
  containerId: string | undefined = GTM_CONTAINER_ID
): boolean {
  if (!containerId) return false;
  if (window.__gtmInitialized) return false;

  const dataLayer = ensureDataLayer();
  dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
  loadGtmScript(containerId);
  window.__gtmInitialized = true;
  return true;
}
